import clsx from 'clsx';
import React from 'react';

import styles from '../styles.module.css';

export const Visit = () => {
  const cn = clsx(
    styles.siteButton,
    'text-center w-4/5 mt-3 border border-solid',
  );

  return (
    <a
      href="https://www.mogulproductions.com/"
      target="_blank"
      className={cn}
      rel="noreferrer"
    >
      Visit Site
    </a>
  );
};
